<script lang="ts">
    import { hamburger_menu_open, menu_components, api_host, user_store, subdomain_manager, bpm_domain, company_details_store, redirect_uri } from './stores.js';
    import breakpoints from "./utils/breakpoints";
    import Router, { push } from 'svelte-spa-router';
    import { wrap } from 'svelte-spa-router/wrap';
    import Hamburger from './utils/Hamburger.svelte';
    import MenuItem from './components/MenuItem.svelte';
    import Responsivemenu from "./utils/responsivemenu.svelte";
    import Dashboard from './components/dashboard.svelte';
    import Jobs from './components/jobs/jobs.svelte';
    import JobReview from './components/jobs/jobreview.svelte';
    import JobEdit from './components/jobs/jobedit.svelte';
    import JobCreate from './components/jobs/jobcreate.svelte';
    import RedirectJobCreate from './components/jobs/jobcreate_refresh.svelte';
    import Referrals from './components/referrals/referrals.svelte';
    import Giftcards from './components/giftcards.svelte';
    import GiftcardsReview from './components/giftcardsreview.svelte';
    import GiftcardsEdit from './components/giftcardsedit.svelte';
    import GiftcardsCreate from './components/giftcardscreate.svelte';
    import Content from './components/contents/content.svelte';
    import Invoices from './components/invoices/invoices.svelte';
    import InvoiceReview from './components/invoices/invoicereview.svelte';
    import Users from './components/users/users.svelte';
    import UserReview from './components/users/usersreview.svelte';
    import UserEdit from './components/users/usersedit.svelte';
    import UserCreate from './components/users/userscreate.svelte';
    import UsersImport from './components/users/usersimport.svelte';
    import SystemCheck from './components/systemcheck.svelte';
    import Report from './components/report.svelte';
    import Quotes from './components/quotes/quotes.svelte';
    import Quotecreate from "./components/quotes/quotecreate.svelte";
    import Quotereview from "./components/quotes/quotereview.svelte";
    import Quoteedit from "./components/quotes/quoteedit.svelte"
    
    import Coupons from './components/coupons/coupons.svelte';
    import CouponReview from './components/coupons/couponsreview.svelte';
    import CouponEdit from './components/coupons/couponsedit.svelte';
    import CouponCreate from './components/coupons/couponscreate.svelte';
    import Settingsprice from './components/settings/settingsprice.svelte';
    import Paymentreport from './components/paymentreports/paymentreport.svelte';
    import Crewcontractors from './components/crewcontractors.svelte';
    import Crewemployees from './components/crewemployees.svelte';

    import Settingsemail from "./components/settings/settingsemail.svelte";
    import Settingspayment from "./components/settings/settingspayment.svelte";
    import Settingsnotification from "./components/settings/settingsnotification.svelte";
    import Settingssubscription from "./components/settings/settingssubscription.svelte";
    import Settingsbilling from "./components/settings/settingsbilling.svelte";
    import Settingsfeature from "./components/settings/settingsfeature.svelte";
    import Settingscompany from "./components/settings/settingscompany.svelte";
    import Settingsdomain from "./components/settings/settingsdomain.svelte";
    import Settingsplan from './components/settings/settingsplan.svelte';
    import Settingsregister from './components/settings/settingsregister.svelte';
    import Settingspage from './components/settings/settingspage.svelte';
    
    import Accountingexpenses from "./components/accounting/accountingexpenses.svelte";
    import Accountingcateogry from "./components/accounting/accountingcategory.svelte";
    import Accountingpl from "./components/accounting/accountingpl.svelte";
    import Expenseview from "./components/accounting/expenseview.svelte";
    import Expenseedit from "./components/accounting/expenseedit.svelte";

    import Places from './components/places/places.svelte';
    import Placescities from './components/places/placescities.svelte';

    import Contenthomepage from "./components/contents/contenthomepage.svelte";
    import Contentembed from "./components/contents/contentembed.svelte";
    import Contentbookingpage from "./components/contents/contentbookingpage.svelte";
    import Contentreferral from "./components/contents/contentreferral.svelte";
    import Contentgiftcard from "./components/contents/contentgiftcard.svelte";
    import Contentcoupon from "./components/contents/contentcoupon.svelte";
    import Contenttos from "./components/contents/contenttos.svelte";
    import Contentprivacy from "./components/contents/contentprivacy.svelte";
    import Contentjobapplications from "./components/contents/contentjobapplications.svelte";

    import Searchlog from "./components/searchlog.svelte";
    import Pricetest from "./components/pricetest.svelte";

    import RedirectUserReview from "./utils/redirectuserreview.svelte";
    import RedirectTo from "./utils/RedirectTo.svelte";

    import { createEventDispatcher } from "svelte";
    import { getToken, doFetch } from "./utils/Fetching.js";
    import { handle_not_subscribed } from './utils/format.js';


    const { auth_type, auth_token, domain_code } = getToken();

    let left_menu_components = menu_components;
    let outside_check = false;
    let profile_menu_open = false;
    let selected_corner_menu = '';
    let my_company_domain = '#';
    let my_company_name = '';
    let myself = {};
    user_store.subscribe(value => {
        myself = value;
        if (!myself['is_authenticated']) {
            left_menu_components.forEach(menu_component => {
                if (menu_component['id'] === 'content') {
                    menu_component['m'] = 'link';
                }
            });
        }
    });

    createEventDispatcher();
    const bp = breakpoints();

    subdomain_manager.subscribe(value => {
        my_company_domain = `https://${value}.${bpm_domain}`;
    });
    company_details_store.subscribe(value => {
        my_company_name = value['business_name'];
    });
    
    const tmi = left_menu_components.filter(item => item.m === "submenu");

    let link_items = [];

    left_menu_components.forEach(ni => {
        if (ni.m === "link" && !(ni.c in link_items)) {     
            link_items.push([ni.c, eval(ni.c), ni.id]);
        } else {
            if("sm_items" in ni) {
                ni.sm_items.forEach(mi => {
                    if(mi.m === "link" && !(mi.c in link_items)){
                        link_items.push([mi.c, eval(mi.c), ni.id]);
                    }
                });
            }
        }
    });

    // hard links
    const routes = {
        '/': Dashboard,
        '/Job_Review': JobReview,
        '/Job_Edit': JobEdit,
        '/Job_Create': JobCreate,
        '/GiftCard_Review': GiftcardsReview,
        '/GiftCard_Edit': GiftcardsEdit,
        '/GiftCard_Create': GiftcardsCreate,
        '/Coupon_Review': CouponReview,
        '/Coupon_Edit': CouponEdit,
        '/Coupon_Create': CouponCreate,
        '/User_Review': UserReview,
        '/User_Edit': UserEdit,
        '/User_Create': UserCreate,
        '/Users_Import': UsersImport,
        '/Invoice_Review': InvoiceReview,
        '/Placescities': Placescities,
        // '/Settings_Price': Settingsprice,
        '/Expense_Review': Expenseview,
        '/Expense_Edit': Expenseedit,
        '/Quote_Create': Quotecreate,
        '/Quote_Review': Quotereview,
        '/Quote_Edit': Quoteedit,
        '/Redirect_User_Review': RedirectUserReview,
        '/Redirect_Job_Create': RedirectJobCreate,
        // '/Contenthomepage/free': Contenthomepage,
        '/Contentembed': Contentembed,
        '/Choose_Plan': Settingsplan,
        '/Register_Plan': Settingsregister,
        '/RedirectTo': RedirectTo,
    };
    
    // menu items
    link_items.forEach((ni) => {
        routes[`/${ni[0]}`] = wrap({
            component: ni[1],
            userData: {id: ni[2]}
        });        
    });

    function adjust_menu() {
        $hamburger_menu_open = ($bp === "desktop") ? false: $hamburger_menu_open;
        const status = ($bp === "desktop" || $hamburger_menu_open === true);
        return status;
    }

    $: show_menu = adjust_menu($hamburger_menu_open, $bp);

    function routeEvent(event) {
        if (document.getElementsByClassName("selectedcontentholder")[0]) {
            document.getElementsByClassName("selectedcontentholder")[0].scrollTop = 0;
        }
        const event_details = event.details;
    }

    setTimeout(()=>{$hamburger_menu_open = false; window.scrollTo(0, 0);}, 250);

    const doSelection = async (e) => {
        profile_menu_open = false;
        const selection = e.target.value;
        if (selection === 'logout') {
            const res = await doFetch(
                api_host + '/auth/logout',
                'POST',
                {},
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            localStorage.removeItem('HoyToKenTy');
            localStorage.removeItem('HoyToKenTo');
            if (myself['role'] !== 'landscaper') { window.location.href = my_company_domain; }
            else { window.location.reload(); }
        }
        if (selection === 'help') {
            window.open('https://houseofyards.tawk.help/', '_blank');
            return;
        }
        if (selection === 'profile') {
            push(`#/User_Review?uid=${myself['id']}`);
        }
        selected_corner_menu = 'temp';
    }

	function clickOutside(element, callbackFunction) {
		function onClick(event) {
			if (!element.contains(event.target)) {
				callbackFunction();
			}
		}
		
		document.body.addEventListener('click', onClick);
		
		return {
			update(newCallbackFunction) {
				callbackFunction = newCallbackFunction;
			},
			destroy() {
				document.body.removeEventListener('click', onClick);
			}
		}
	}
</script>


<svelte:head>
    {#if my_company_name}
	    <title>{my_company_name}</title>
    {/if}
    {#if !myself['is_authenticated']}
    <script src="https://www.google.com/recaptcha/api.js?render=6LczIjMgAAAAAA7Iat2xKfRAz7HLG5cHI-lno56y"></script>
    {/if}
</svelte:head>

<div class={"maincontent"}>
    <div class="toolbar">
        {#if myself['is_authenticated']}
            <div class="companyname"><a target="_blank" href={my_company_domain}>{my_company_name || ''}</a></div>
        {:else}
            <div class="companyname">
                <img src="https://cms.houseofyards.com/uploads/logo_160edb88b6.png" alt="houseofyards-logo.png" class="logo svelte-1xkxvpk" >
            </div>
        {/if}
        {#if myself['is_authenticated']}
            {#if !show_menu}
                <i class='fa fa-refresh' on:click={() => { window.location.reload(); }}></i>
            {/if}
            <div class="usertools">
                <span style='cursor: pointer;' on:click={() => { profile_menu_open = !profile_menu_open; }}>
                    &#xf007; &nbsp; {`${myself['first_name'] || ''} ${myself['last_name'] || ''}`}
                    <i class="fas {profile_menu_open ? "fa-angle-up" : "fa-angle-down"}"></i>
                </span>
                <select
                    bind:value={selected_corner_menu}
                    on:input={doSelection}
                    use:clickOutside={() => { if (profile_menu_open) {
                        if (outside_check) { profile_menu_open = false; }
                        outside_check = !outside_check;
                    }}}
                    class='select_cover'
                    style="display: {profile_menu_open ? "block" : "none"};"
                    size={3}
                >
                    <option class='option_item' value="profile" on:click={() => {
                        if (!myself['is_subscribed']) {
                            handle_not_subscribed(myself['is_authenticated'], myself['is_domain_expired']);
                            return;
                        }
                        push(`#/User_Review?uid=${myself['id']}`);
                        profile_menu_open = false;
                        outside_check = !outside_check;
                    }}>&#xf007; &nbsp; Profile</option>
                    <option class='option_item' value="logout">&#xf2f5; &nbsp; Logout</option>
                    <option class='option_item' value="help" on:click={() => {
                        window.open('https://houseofyards.tawk.help/', '_blank');
                        profile_menu_open = false;
                        outside_check = !outside_check;
                    }}>&#xf059; &nbsp; Help</option>
                    <option class='option_item' value="temp" style='display: none;'>temp</option>
                </select>
            </div>
        {/if}
        <div class="hamburgermenu"><Hamburger bind:open={$hamburger_menu_open}/></div>
    </div>

    {#if show_menu}
        <div class="menubar">
            {#if myself['is_authenticated']}
            <MenuItem 
                title="New Job"
                hash_link="#/Redirect_Job_Create"
                menu_icon="far fa-calendar-plus"
                mobile_only={true}
                handle_directly={true}
            />
            {/if}

            <Responsivemenu 
                menu_items={left_menu_components}
            />

            <MenuItem
                title="Help"
                menu_icon="fas fa-question-circle"
                mobile_only={true}
                handle_directly={true}
            />
            <MenuItem 
                title="Profile"
                menu_icon="fas fa-user"
                mobile_only={true}
                handle_directly={true}
            /> 
            <MenuItem
                title="Logout"
                menu_icon="fas fa-sign-out-alt"
                mobile_only={true}
                handle_directly={true}
            />
        </div>
    {/if}

    {#if !$hamburger_menu_open}
    <div class="selectedcontentholder">
        <div style="height: 100%;">
            <Router {routes} on:routeLoaded={routeEvent}/>
            {#if false}
                <Dashboard />
                <Settingsprice />
                <Jobs />
                <Referrals />
                <Giftcards />
                <Coupons />
                <Content />
                <Contenthomepage />
                <Contentembed />
                <Contentbookingpage />
                <Contentreferral />
                <Contentgiftcard />
                <Contentcoupon />
                <Contenttos />
                <Contentprivacy />
                <Contentjobapplications />
                <Places />
                <Invoices />
                <Users />
                <SystemCheck />
                <Paymentreport />
                <Quotes />
                <Report />
                <Crewcontractors />
                <Crewemployees />
                <Settingsemail />
                <Settingspayment />
                <Settingsnotification />
                <Settingsbilling />
                <Settingssubscription />
                <Settingsfeature />
                <Settingscompany />
                <Settingsdomain />
                <Settingsregister />
                <Settingspage />
                <Accountingexpenses />
                <Accountingpl />
                <Expenseview />
                <Expenseedit />
                <Searchlog />
                <Pricetest />
            {/if}
        </div>
    </div>
    {/if}
</div>


<style>
    .fa.fa-refresh:before { content: "\f021"; }
    .fa-refresh { cursor: pointer; }
    :global(button) {
        cursor: pointer;
    }
    .usertools {
        font-family: Poppins, "Font Awesome 5 Pro", "FontAwesome", "Font Awesome 5 Free" !important;	
        display: flex;
        align-items: center;
        margin-right: 10px;
    }
    .usertools select {
        border: none;
        background-color: white;
    }
    .usertools select option{
        border: none;
        background-color: white;
    }
    .toolbar {
        grid-area: tb;
        width: 100%;
        border-bottom: 1px solid #333;
        box-shadow: 0px 10px 5px -2px #888;
        background-color: #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .toolbar .companyname {
        padding-left: 10px;
    }
    .toolbar .hamburgermenu {
        padding-right: 10px;
        display: none;
    }
    .menubar {
        grid-area: mb;
        min-width: 240px;
        max-width: 240px;
        height: 100%;
        overflow-y: auto;
        border-right: 1px solid #333;
        width: 100%;
        box-shadow: 10px 0 5px -2px #888;
        background-color: #888;
        color: whitesmoke;
        display: flex;
        flex-direction: column;
        padding: 0px;
    }
    :global(.menubuttonholder) {
        padding: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
        width: 100%;
    }
    :global(.menubuttonholder button){
        width: 100%;
        height: 100%;
        margin-top: 0px;
        margin-bottom: 0px;
        background-color: #888;
        color: whitesmoke;
        text-align: left;
        border-bottom: 1px solid whitesmoke;
		z-index: 20;
    }
    :global(.menubuttonholder button:hover) {
        background-color: green;
        color: white;
    }

    :global(.menubuttonholder button i.menuindicator) {
        float: right;
        margin-top: 4px;
        margin-right: 10px;
    }
    :global(.menubuttonholder button i.menuitemicon) {
        margin-right: 10px;
    }

    :global(.subitem button){
        background-color: #BBB;
        color: black;
        padding-left: 20px;
        border-bottom: 1px solid black;
		z-index: 20;
    }
    .selectedcontentholder {
        grid-area: sc;
        width: 100%;
        overflow-y: scroll;
        padding: 15px;
        box-sizing: border-box;
        margin-bottom: 15px;
    }
    .logo {
        margin: auto 0;
        height: 40px;
        margin-right: 15px;
        cursor: pointer;
    }
    .maincontent {
        margin: 0px;
        width: 100%;
        height: 100vh;
        display: grid;
        /* grid-template-columns: repeat(12, 1fr); */
        grid-template-columns: 240px auto;
        grid-template-rows: 50px auto;
        grid-template-areas: "tb tb"
                             "mb sc";
    }
    @media (max-device-width: 1025px), (max-width: 1024px) {
        .maincontent {
            margin: 0px;
            width: 100%;
            height: 100%;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: 50px 0px auto;
            grid-template-areas: "tb"
                                 "mb"
                                 "sc";
        }
        .menubar {
            min-width: 100%;
            max-width: 100%;
            width: 100%;
            height: 100vh;
            height: calc(var(--vh, 1vh) * 100 - 150px);
            overflow-y: auto;
            grid-area: mb;
        }
        .toolbar .hamburgermenu {
            padding-right: 10px;
            display: block;
        }
        .usertools {
            display: none;
        }
        .selectedcontentholder {
            grid-area: sc;
            width: 100%;
            /* padding: 0px; */
            overflow-y: scroll;
            margin-bottom: 15px;
        }
    }
    .select_cover {
        display: block;
        position: absolute;
        top: 40px;
        right: 5px;
        width: 120px;
        height: 110px;
        border-radius: 2px;
        border: 1px solid lightgray!important;
        padding: 0px;
        z-index: 100;
    }
    .option_item {
        padding-left: 15px;
        padding-top: 7px;
        height: 35px;
    }
   
    :global(body) {
        padding: 0 0 0 0 !important;
        margin: 0 0 0 0 !important;
    }

</style>
